import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ({title, cancelLabel, confirmLabel, show, onConfirm, onCancel, children}) {

    return (
        <div>
            <Dialog
                open={show}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {children}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel} color="primary">
                        {cancelLabel}
                    </Button>
                    <Button onClick={onConfirm} color="primary" autoFocus>
                        {confirmLabel}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
